import CallAPI from "../../utility/functions/getData";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import dataToLocal from "../../utility/component/dataToLocal";
import deleteWholeDatabase from "../../utility/functions/deleteWholeDatabase";

export const GetSaleSummary = (
  data,
  token,
  dispatch,
  setSummaryList,
  saleType,
  item,
  setFullList,setTotalPages,
  setCurrentPage,setTotalFields
) => {
  console.log(saleType);
  dispatch(setSpinnerLoading("Loading"));
  deleteWholeDatabase("sale_summary");
  CallAPI(
    "/api/saleReports/saleSummary",
    {
      ...data,
      ITEMNAME: item ? item : "",
      BILL_PERFORMA: saleType === "Retail" ? "bills" : "orders",
    },
    token,
    (e) => {
      if (!e.data.error) {
     
        if (e.data.response[0]) {
          const list =
            saleType === "Retail"
              ? e.data.response
              : saleType !== "Dealer Order"
              ? e.data.response.filter(
                  (o) =>
                    o.ORDER_TYPE?.toLowerCase() === "pickup" ||
                    o.ORDER_TYPE?.toLowerCase() === "delivery"
                )
              : e.data.response.filter((o) => o.ORDER_TYPE === "Dealer Order");
          setSummaryList(list);
          setTotalPages(e.data.totalPages)
          setCurrentPage(e.data.page)
          if (setFullList) {
            setFullList(list);
          }
          dataToLocal("sale_summary", list, [
            {
              ...data,
              ICODE: 1,
              totalFields:e.data.totals
            },
          ]);
          if(setTotalFields){
            setTotalFields(e.data.totals)
          }
        } else {
          setSummaryList([]);
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No Records Found",
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
